import { useQuery } from '@tanstack/react-query';

import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { unwrapNonPaginatedResponseDataAs } from '../../../logic/unwrapNonPaginatedResponseDataAs';
import { DOCUMENTS_BASE_PATH } from '../../constants/documentsBasePath';
import { getDocumentHooks } from '../../requests/getDocumentHooks';

export const useDocumentHooks = (
  documentId: string,
  definitionName: string,
  statusDefinitionName?: string,
  options?: { enabled?: boolean },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getDocumentHooks>>
  >({
    queryKey: [DOCUMENTS_BASE_PATH, documentId, 'hooks', statusDefinitionName],
    queryFn: () =>
      getDocumentHooks(
        constructGet,
        documentId,
        definitionName,
        statusDefinitionName,
      ),
    enabled: Boolean(documentId) && (options?.enabled ?? true),
  });

  return {
    ...unwrapNonPaginatedResponseDataAs(data, refetch, 'hooks'),
    ...rest,
  };
};
